import { Component, EventEmitter, Output } from '@angular/core';
import { Modal } from 'bootstrap';

import { AuthService } from 'src/app/auth/auth.service';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { AccommodationService, MoveData } from '../../accommodation.service';
import { Permissions } from '@/common/enums/Permissions';

@Component({
	selector: 'app-accommodation-list-reservation',
	templateUrl: './accommodation-list-reservation.component.html',
	styleUrls: ['./accommodation-list-reservation.component.css'],
})
export class AccommodationListReservationComponent {
	@Output() move = new EventEmitter();
	reservation = null;

	readonly Permissions = Permissions;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly service: AccommodationService,
		public auth: AuthService,
	) {}

	open(reservation) {
		this.reservation = reservation;
		this.api.get('/istour/istourAccommodations/' + reservation.id, (result, error) => {
			if (error) {
				return;
			}
			this.reservation.persons = result.data.persons;
			this.reservation.commentIstour = result.data.commentIstour;
			this.reservation.comment = result.data.comment;
			new Modal(document.getElementById('reservationModal')).show();
		});
	}

	close(): void {
		const modal = Modal.getInstance(document.getElementById('reservationModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	changeProductStart(): void {
		this.close();
		this.service.move.next(<MoveData>{
			type: 'changeProduct',
			step: 'begin',
			reservation: this.reservation,
		});
	}

	moveStart(): void {
		this.close();
		this.move.emit(this.reservation);
	}

	moveStartDok(): void {
		this.close();
		this.service.move.next(<MoveData>{
			type: 'dok',
			step: 'begin',
			reservation: this.reservation,
		});
	}

	saveComment(comment): void {
		const data = {
			cmd: 'saveComment',
			businessCase: comment.businessCase,
			comment: comment.data,
		};
		this.api.command('/istour/istourAccommodations/' + this.reservation.id, data, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisane');
		});
	}
}
